import { render } from "./012-CulturalExhibition.vue?vue&type=template&id=be78287c&scoped=true"
import script from "./012-CulturalExhibition.vue?vue&type=script&lang=js"
export * from "./012-CulturalExhibition.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=be78287c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be78287c"]])

export default __exports__